import { useCallback } from "react";
import { useUserContext } from "./UserContext";
import { getLoggedInUser } from "../api";

export const useTokenValidation = () => {
  const { user, clearUserSession, navigate } = useUserContext();

  const validateToken = useCallback(async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      clearUserSession();
      return false;
    }

    try {
      const response = await getLoggedInUser({ token });
      return response?.data?.data ? true : false;
    } catch (error) {
      if (error.response?.status === 401) {
        clearUserSession();
        return false;
      }
      // For other errors, assume token is still valid
      return true;
    }
  }, [clearUserSession]);

  const isTokenValid = useCallback(() => {
    const token = localStorage.getItem("token");
    return !!token && !!user;
  }, [user]);

  const requireValidToken = useCallback(
    async (callback) => {
      const token = localStorage.getItem("token");

      if (!token || !user) {
        clearUserSession();
        navigate("/login");
        return false;
      }

      const isValid = await validateToken();
      if (!isValid) {
        clearUserSession();
        navigate("/login");
        return false;
      }

      return callback ? await callback() : true;
    },
    [user, validateToken, clearUserSession, navigate]
  );

  return {
    validateToken,
    isTokenValid,
    requireValidToken,
  };
};
